// ============================================
// ACTION HOOKS
// Combines hooks from:
// - [RecommendsAction.tsx] RecommendsAction (top-level) (ACTION 160)
// ============================================

import {useEffect} from 'react';
import {actionFieldsType} from '../RecommendsAction/actionFields';
import {useRecommendContext} from '../CreateRecommend/CreateRecommendHelpers';
import {
  useAutoField,
  useLoadedAutoField,
  AutoFieldHelpers,
} from '../../../components/AutoForm/useAutoForm';
import {UPDATES} from '../../../shared/UPDATES';
import {OVRecommendation} from '../../../schema-types/OVRecommendation';

export const loadActionNotes = ({
  recommendDetails,
  helpers,
  setLoaded,
}: {
  recommendDetails: OVRecommendation | null;
  helpers: AutoFieldHelpers<actionFieldsType['note']>;
  setLoaded: () => void;
}) => {
  if (!recommendDetails) {
    setLoaded();
    return;
  }
  helpers.setValue(UPDATES._160, recommendDetails.note || '');
  setLoaded();
};

export const useLoadActionNotes = () => {
  const {loaded, setLoaded} = useLoadedAutoField();
  const [_, __, helpers] = useAutoField<actionFieldsType['note']>('action.note');
  const {recommendDetails} = useRecommendContext();
  useEffect(() => {
    loadActionNotes({recommendDetails, helpers, setLoaded});
  }, [recommendDetails]);
  return {loaded};
};
